import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b444fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "Search_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "计划日期", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_5 = { class: "Search_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "生产工厂", -1))
const _hoisted_7 = { class: "Search_item_content" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "Search_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Search_item_label" }, "工序", -1))
const _hoisted_12 = { class: "Search_item_content" }
const _hoisted_13 = { class: "tag" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_search_x" }, null, -1))
const _hoisted_16 = { class: "content_total" }
const _hoisted_17 = { class: "content_list" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "content_list_item_top" }
const _hoisted_20 = { class: "content_list_item_top_left" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "content_list_item_top_left_tag"
}
const _hoisted_23 = {
  key: 2,
  class: "content_list_item_top_left_tag warning"
}
const _hoisted_24 = { class: "content_list_item_top_right" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { key: 6 }
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { key: 8 }
const _hoisted_34 = { class: "content_list_item_content" }
const _hoisted_35 = {
  key: 0,
  class: "content_list_item_content_item"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "工序名称：", -1))
const _hoisted_37 = { class: "content_list_item_content_item_nr" }
const _hoisted_38 = { class: "content_list_item_content_item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划日期：", -1))
const _hoisted_40 = { class: "content_list_item_content_item_nr" }
const _hoisted_41 = { class: "content_list_item_content_item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "物料编码：", -1))
const _hoisted_43 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_44 = { class: "content_list_item_content_item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划数量：", -1))
const _hoisted_46 = {
  key: 0,
  class: "content_list_item_content_item_nr"
}
const _hoisted_47 = { class: "content_list_item_content_item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产批次：", -1))
const _hoisted_49 = { class: "content_list_item_content_item_nr" }
const _hoisted_50 = { class: "content_list_item_content_item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "发布日期：", -1))
const _hoisted_52 = { class: "content_list_item_content_item_nr" }
const _hoisted_53 = { class: "content_list_item_content_item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划人员：", -1))
const _hoisted_55 = { class: "content_list_item_content_item_nr" }
const _hoisted_56 = { class: "content_list_item_content_item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "生产工厂：", -1))
const _hoisted_58 = { class: "content_list_item_content_item_nr" }

import { reactive, ref, onMounted } from "vue"
    import { useRouter } from "vue-router"
    import { gsdate } from '@/utils/utils'
    import { getList, pageCount } from '@/apis/PlanningAPI'
    import { getWorkingProcedure, getOrganization } from '@/apis'
    import { judgmentPlatform } from '@/utils/utils'
    import { model } from '@/interface'
    import vSearch from '@/components/common/Search.vue'
    import vLableSelection from '@/components/common/LabelSelection.vue'

    // 分页/查询-----接口
    interface PagingType extends model {
        total: number,
        startDate: string,
        endDate: string,
        procedureIds: Array<any>,
        departIds: string | number,
        cateIds: Array<any>
    }

    // 分页/查询-----数据
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const listData = reactive<PagingType>({
        capacity: 10,
        page: 0,
        total: 0,
        startDate: '',
        endDate: '',
        procedureIds: [],
        departIds: '',
        mixParam: '',
        cateIds: []
    })

    const router = useRouter()

    const minDate: Date = new Date(2021, 0, 1)

    const maxDate: Date = new Date(new Date().getFullYear() + 1, 12, 30)

    // 工序数据
    let data: any = ref([])

    // 工厂数据
    let factoryList: any = ref([])

    // 列表数据
    let lists: any = ref([])

    // 控制打开日历插件
    const isOpenDate = ref<boolean>(false)

    // 根据平台是否需要设置top
    let status = ref<boolean>(false)

    const list: any = ref<Array<object>>([])
    const loading = ref<boolean>(false)
    const finished = ref<boolean>(true)
    const refreshing = ref(false)

    // 搜索标签数据
    const tagList = reactive<Array<{ id: Array<number>, name: string, num: string }>>([
        {
            id: [],
            name: '全部',
            num: '0'
        },
        {
            id: [0],
            name: '待发布',
            num: '0'
        },
        {
            id: [1, 4],
            name: '生产中',
            num: '0'
        },
        {
            id: [6, 7, 3, 8],
            name: '已完成',
            num: '0'
        }
    ])

    // 重置
    const reset = () => {
        listData.page = 0
        finished.value = false
        lists.value = []
        listData.mixParam = ''
        listData.startDate = ''
        listData.endDate = ''
        listData.procedureIds = []
        if (factoryList.value.length > 0) {
            listData.departIds = factoryList.value[0].id
        }
        data.value.forEach((item: any) => { item.isActive = false })
        getLists()
        pageCounts()
    }

    // 获取列表统计
    const pageCounts = () => {
        pageCount({
            factoryId: listData.departIds,
            procedureIdList: listData.procedureIds ? listData.procedureIds : [],
            startDate: listData.startDate,
            endDate: listData.endDate,
            statusList: listData.cateIds
        })
            .then(res => {
                if (res.code === 200 && res.data) {
                    tagList[0].num = res.data.allNum.toString()
                    tagList[1].num = res.data.startNum.toString()
                    tagList[2].num = res.data.ingNum.toString()
                    tagList[3].num = res.data.endNum.toString()
                }
            })
    }

    // 获取工厂数据
    const getOrganizations = () => {
        getOrganization({
            type: 1
        }).then((res: any) => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                res.data.forEach((item: any, i: number) => {
                    item.isActive = i === 0;
                })
                if (res.data.length > 0) {
                    factoryList.value = res.data
                    listData.departIds = factoryList.value[0].id
                    listData.procedureIds = '' as never
                    finished.value = false
                    getWorkingProcedures(factoryList.value[0].id)
                    getLists()
                    pageCounts()
                }
            }
        })
    }

    // 获取工序数据
    const getWorkingProcedures = (orgId: string | number): void => {
        data.value = []
        getWorkingProcedure({ orgId })
            .then((res: any) => {
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    res.data.forEach((item: any, i: number) => {
                        item.isActive = false;
                    })
                    data.value = res.data
                }
            })
    }

    // 获取计划列表数据
    const getLists = (): void => {
        if (!finished.value) {
            loading.value = true
            listData.page = listData.page + 1
            getList({
                capacity: listData.capacity,
                model: {
                    mixParam: listData.mixParam,
                    startDate: listData.startDate,
                    endDate: listData.endDate,
                    procedureIdList: listData.procedureIds ? listData.procedureIds : [],
                    factoryId: listData.departIds,
                    statusList: listData.cateIds
                },
                page: listData.page,
                sorts: [
                    {
                        direction: 'ASC',
                        property: 'publishDate'
                    }
                ]
            }).then((res: any) => {
                loading.value = false
                listData.total = res.data.total
                if (refreshing.value) {
                    lists.value = []
                    refreshing.value = false;
                }
                if (res.code === 200 && res.data.records.length !== 0) {
                    if (lists.value.length === 0) {
                        lists.value = res.data.records
                    } else {
                        lists.value.push(...res.data.records)
                    }
                } else {
                    finished.value = true
                }
            }).catch((err: any) => {
                loading.value = false
                finished.value = true
                if (refreshing.value) {
                    lists.value = []
                    refreshing.value = false;
                }
            })
        }
    }

    // 下拉刷新优化页面
    const onRefresh = () => {
        finished.value = false;
        listData.page = 0
        loading.value = true;
        getLists();
        pageCounts()
    }

    // 接收子组件传来的输入框值
    const searchInput = (val: string): void => {
        listData.mixParam = val
        listData.page = 0
        finished.value = false
        lists.value = []
        getLists()
    }

    // 搜索弹框提交
    const submit = (): void => {
        let pmodelOrgId: any[] = []
        data.value.forEach((item: any) => {
            if (item.isActive) {
                pmodelOrgId.push(item.id)
            }
        })
        listData.procedureIds = pmodelOrgId
        listData.page = 0
        finished.value = false
        lists.value = []
        getLists()
        pageCounts()
    }

    // 打开日期插件
    const openDate = (): void => {
        isOpenDate.value = true
    }

    // 确认选择时间
    const onConfirm = (values: any): void => {
        const [start, end] = values;
        listData.startDate = gsdate(start)
        listData.endDate = gsdate(end)
        isOpenDate.value = false;
    };

    // 点击标签搜索
    const clickTag = (ids: any): void => {
        listData.cateIds = ids
        listData.page = 0
        finished.value = false
        lists.value = []
        getLists()
    }

    // 切换工厂
    const changeTags = (i: any, id: string | number): void => {
        listData.departIds = id
        getWorkingProcedures(id)
        factoryList.value.forEach((item: { isActive: boolean; }, index: any) => {
            if (index === i) {
                item.isActive = true
            } else {
                item.isActive = false
            }
            // item.isActive = index === i;
        })
    }

    // 切换工序
    const changeTag = (i: any): void => {
        data.value[i].isActive = !data.value[i].isActive
    }

    // 跳转详情
    const jump = (item: any): void => {
        router.push({ name: 'progressDetails', query: { id: item.id } })
    }

    onMounted(() => {
        status.value = judgmentPlatform()
        getLists()
        // pageCounts()
        // getWorkingProcedures()
        getOrganizations()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'content_top': _unref(status) }, "content_search"])
    }, [
      _createVNode(vSearch, {
        ref: "Search",
        onSearchInput: searchInput,
        onSubmit: submit,
        onReset: reset,
        isShow: true,
        placeholder: "搜索物料名称/编码/工序名称"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "Search_item_content",
              onClick: openDate
            }, [
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).startDate ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).startDate ? _unref(listData).startDate : '开始日期'), 5),
              _hoisted_4,
              _createElementVNode("div", {
                class: "Search_item_content_a",
                style: _normalizeStyle(_unref(listData).endDate ? 'color: #000' : '')
              }, _toDisplayString(_unref(listData).endDate ? _unref(listData).endDate : '结束日期'), 5)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: item.id,
                    onClick: ($event: any) => (changeTags(i, item.id))
                  }, _toDisplayString(item.name), 11, _hoisted_9))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tag_item", {'tag_active': item.isActive}]),
                    key: item.id,
                    onClick: ($event: any) => (changeTag(i))
                  }, _toDisplayString(item.name), 11, _hoisted_14))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _hoisted_15,
      _createVNode(vLableSelection, {
        TagList: _unref(tagList),
        isShow: true,
        onChange: clickTag
      }, null, 8, ["TagList"])
    ], 2),
    _createElementVNode("div", _hoisted_16, "共" + _toDisplayString(_unref(listData).total) + "条数据", 1),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了~",
          onLoad: getLists
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lists), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content_list_item",
                  key: item.id,
                  onClick: ($event: any) => (jump(item))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      (item.mmodel)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.mmodel.name), 1))
                        : _createCommentVNode("", true),
                      (item.urgent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "优先" + _toDisplayString(item.urgent), 1))
                        : _createCommentVNode("", true),
                      (item.paused === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, "停"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (item.status === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, "已生成"))
                        : _createCommentVNode("", true),
                      (item.status === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, "已发布"))
                        : _createCommentVNode("", true),
                      (item.status === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "已撤回"))
                        : _createCommentVNode("", true),
                      (item.status === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "已取消"))
                        : _createCommentVNode("", true),
                      (item.status === 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, "已分配"))
                        : _createCommentVNode("", true),
                      (item.status === 5)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, "已暂停"))
                        : _createCommentVNode("", true),
                      (item.status === 6)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "已完工"))
                        : _createCommentVNode("", true),
                      (item.status === 7)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "已入库"))
                        : _createCommentVNode("", true),
                      (item.status === 8)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, "已关闭"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (item.pmodel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, _toDisplayString(item.pmodel.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, _toDisplayString(item.planDate), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      (item.mmodel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(item.mmodel.code), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      (item.umodel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(item.num) + _toDisplayString(item.umodel.name), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, _toDisplayString(item.batch), 1)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString(item.publishDate ? item.publishDate : '-'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createElementVNode("div", _hoisted_55, _toDisplayString(item.usermodel.realname), 1)
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("div", _hoisted_58, _toDisplayString(item.fmodel.name), 1)
                    ])
                  ])
                ], 8, _hoisted_18))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_calendar, {
      show: isOpenDate.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDate).value = $event)),
      "min-date": _unref(minDate),
      "max-date": _unref(maxDate),
      type: "range",
      onConfirm: onConfirm,
      color: "#4275FC"
    }, null, 8, ["show", "min-date", "max-date"])
  ]))
}
}

})